// Thin local client for submitting the booking-step intake (the SDK doesn't carry it yet). Same auth
// as the other patient calls: Cognito bearer + credentials:include (dev cookie). Best-effort — a failure
// never blocks the booking (the visit is already created); the intake is supplementary.
import { useMemo } from "react";
import { API_ORIGIN } from "../config";
import { useAppAuth } from "../auth";

export interface IntakeResponse {
  q: string;
  a: string;
}
export interface IntakeSubmit {
  category: "medical" | "dental" | "vision";
  form_key: string;
  form_title: string;
  responses: IntakeResponse[];
}

export function useIntakeApi(): { submit(appointmentId: string, intake: IntakeSubmit): Promise<void> } {
  const { getToken } = useAppAuth();
  return useMemo(
    () => ({
      async submit(appointmentId: string, intake: IntakeSubmit) {
        if (!intake.responses.length) return;
        try {
          const headers: Record<string, string> = { "Content-Type": "application/json" };
          const token = await getToken();
          if (token) headers["Authorization"] = `Bearer ${token}`;
          await fetch(
            `${API_ORIGIN}/v1/patient/appointments/${encodeURIComponent(appointmentId)}/intake`,
            { method: "POST", headers, credentials: "include", body: JSON.stringify(intake) },
          );
        } catch {
          /* best-effort */
        }
      },
    }),
    [getToken],
  );
}
